export default "__VITE_ASSET__9a0e6075__"